import { render, staticRenderFns } from "./customerMessage.vue?vue&type=template&id=f5cf8b02&scoped=true"
import script from "./customerMessage.vue?vue&type=script&lang=js"
export * from "./customerMessage.vue?vue&type=script&lang=js"
import style0 from "./customerMessage.vue?vue&type=style&index=0&id=f5cf8b02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cf8b02",
  null
  
)

export default component.exports